
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment/plans/[[...lang]]",
      function () {
        return require("private-next-pages/payment/plans/[[...lang]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment/plans/[[...lang]]"])
      });
    }
  